/* 🤖 this file was generated by svg-to-ts */
export const matIconVideoChat: {
  name: 'video-chat';
  data: string;
} = {
  name: 'video-chat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/><path d="M8 14h6c.55 0 1-.45 1-1v-1.99L17 13V7l-2 1.99V7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"/></svg>`
};
